import { HubUserAttributesClient } from 'frontend-preferences-client';
export const hubUserAttributesClient = HubUserAttributesClient.forCaller('ui-addon-conversations-settigns');